import { startParam } from "./telegram";

export type StartParamResult =
  | { kind: "group"; telegramChatId: number }
  | { kind: "add"; telegramChatId: number }
  | { kind: "receipt"; telegramChatId: number }
  | { kind: "settle"; telegramChatId: number }
  | { kind: "pending"; telegramChatId: number }
  | { kind: "history"; telegramChatId: number }
  | { kind: "receipt_detail"; telegramChatId: number; receiptId: string }
  | null;

export function parseStartParam(): StartParamResult {
  if (!startParam) return null;

  // Try receipt detail format: rdetail_CHATID_UUIDNODASHES
  const rd = startParam.match(/^rdetail_(-?\d+)_([0-9a-f]{32})$/);
  if (rd) {
    // Convert 32-char hex back to UUID format with dashes
    const hex = rd[2];
    const receiptId = [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20),
    ].join("-");
    return { kind: "receipt_detail", telegramChatId: Number(rd[1]), receiptId };
  }

  const m = startParam.match(/^(group|add|receipt|settle|pending|history)_(-?\d+)$/);
  if (!m) return null;
  const kind = m[1] as "group" | "add" | "receipt" | "settle" | "pending" | "history";
  return { kind, telegramChatId: Number(m[2]) };
}
